import BroadcastSharedWorker from 'worker-loader?worker=SharedWorker!worker/shared';

const IS_ANGEL =
  new URL(window.location.href).searchParams.get('angel') !== null;

export function listenOnMaintenanceLock() {
  return new Promise((resolve) => {
    fetch(`${serverProfile.maintenanceUrl}?_=${Date.now()}`)
      .then((res) => {
        return res.ok ? res.json() : Promise.reject();
      })
      .then((res) => {
        const data = res && res.creator;
        if (
          !IS_ANGEL &&
          data &&
          data.lock === true &&
          data.lockTimestamp &&
          Date.now() >= data.lockTimestamp
        ) {
          resolve();
        }
      });

    const sharedWorker = new BroadcastSharedWorker();
    sharedWorker.port.onmessage = (e) => {
      const type = (e.data && e.data.type) || null;
      const creator = e.data?.reflection;
      console.debug('sharedWorker - onmessage', type);
      if ('sw-maintenance-data' === type && creator) {
        if (!IS_ANGEL && creator.lock && Date.now() >= creator.lockTimestamp) {
          resolve();
        }
      }
    };
    sharedWorker.port.postMessage({
      type: 'sw-init',
      payload: {
        maintenanceUrl: serverProfile.maintenanceUrl,
      },
    });

    window.addEventListener('unload', () => {
      sharedWorker.port.postMessage({ type: 'sw-window-unload' });
    });

    window.addEventListener('visibilitychange', () => {
      if (!document.hidden) {
        console.debug('👁');
        sharedWorker.port.postMessage({ type: 'sw-maintenance-pull' });
      }
    });
  });
}
